import { cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const createRocketbetCanonicalItems = () => [
    {
        id: 'welcome-deposit-bonus',
        promotion: {
            id: 'welcome-deposit-bonus',
            title: Verbiage.welcome_bonus,
            startDate: new Date('2026-01-01T00:00:00Z'),
            description: Verbiage.up_to_3000_bonus_on_your_first_3_deposits,
            buttonText: Verbiage.claim,
            url: '/casino/',
            banner: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus-detail.png'),
            action: true,
            footerText: Verbiage.rocketbet_promotions_footer_text_3000_welcome_bonus
        },
        surfaces: {},
        order: { promotions: 0 }
    },
    {
        id: 'fury-of-anubis',
        promotion: {
            id: 'fury-of-anubis',
            title: Verbiage.fury_of_anubis,
            description: Verbiage.fury_of_anubis_description,
            buttonText: Verbiage.more_info,
            url: '/promotion-page/fury-of-anubis/',
            startDate: new Date('2026-06-29T08:01:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/fury_of_anubis/fury_of_anubis_carousel_mobile.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/fury_of_anubis/fury_of_anubis_carousel_desktop.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_fury_of_anubis_prize_drops
        },
        topSection: {
            title: Verbiage.fury_of_anubis,
            description: Verbiage.fury_of_anubis_description,
            backgroundImage: cfgToThemeCdnPath('/promotions/fury_of_anubis/fury_of_anubis_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/fury_of_anubis/fury_of_anubis_mobile.png'),
            badgeText: Verbiage.promotion,
            buttonText: Verbiage.more_info,
            link: '/promotion-page/fury-of-anubis/',
            startDate: new Date('2026-06-29T08:01:00Z')
        },
        order: { promotions: 1, topSection: 0 }
    },
    {
        id: 'better-barn-house-bonanza',
        promotion: {
            id: 'better-barn-house-bonanza',
            title: Verbiage.better_barn_house_bonanza,
            description: Verbiage.better_barn_house_bonanza_description,
            buttonText: Verbiage.play_now,
            url: '/p/pragmatic-play/better_barn_house_bonanza/',
            conditionalUrl: {
                loggedInUrl: '/player/p/pragmatic-play/better_barn_house_bonanza/',
                loggedOutUrl: '/p/pragmatic-play/better_barn_house_bonanza/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/better_barn_house_bonanza/better_barn_house_bonanza_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/better_barn_house_bonanza/better_barn_house_bonanza_mobile.png'),
            startDate: new Date('2026-06-22T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/better_barn_house_bonanza/better_barn_house_bonanza_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/better_barn_house_bonanza/better_barn_house_bonanza_mobile.png'),
            badgeText: Verbiage.new_release
        },
        order: { topSection: 1 }
    },
    {
        id: 'tournaments',
        promotion: {
            id: 'tournaments',
            title: Verbiage.weekly_races,
            description: Verbiage.weekly_races_description_2,
            buttonText: Verbiage.start_now,
            url: '/tournaments/#/tournaments/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/races/races_mobile.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/races/races_desktop.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_1500_every_week
        },
        topSection: {
            title: Verbiage.rocket_races,
            description: Verbiage.win_real_cash_prizes_every_week,
            backgroundImage: cfgToThemeCdnPath('/promotions/races/races_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/races/races_mobile.png'),
            badgeText: Verbiage.promotion,
            buttonText: Verbiage.join_the_races,
            link: '/tournaments/#/tournaments/',
            startDate: new Date('2026-06-29T00:00:00Z')
        },
        order: { promotions: 2, topSection: 2 }
    },
    {
        id: 'jackpot',
        promotion: {
            id: 'jackpot',
            title: Verbiage.rocket_jackpot_million_title,
            description: Verbiage.rocket_jackpot_million_description,
            buttonText: Verbiage.play_now,
            url: '/promotion-page/jackpot/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/jackpot/jackpot.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/jackpot/jackpot-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_all_caps
        },
        order: { promotions: 3 }
    },
    {
        id: 'raffles',
        promotion: {
            id: 'raffles',
            title: Verbiage.weekly_raffle,
            description: Verbiage.weekly_raffle_description,
            buttonText: Verbiage.enter_now,
            url: '/tournaments/#/raffles/',
            startDate: new Date('2026-06-29T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/raffles/raffles.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_500_cash_prize
        },
        topSection: {
            title: Verbiage.weekly_raffle,
            description: Verbiage.weekly_raffle_description,
            backgroundImage: cfgToThemeCdnPath('/promotions/raffles/raffles_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/raffles/raffles_mobile.png'),
            badgeText: Verbiage.promotion,
            buttonText: Verbiage.join_the_raffle,
            startDate: new Date('2026-06-29T00:00:00Z')
        },
        order: { promotions: 4, topSection: 3 }
    },
    {
        id: 'weekly-prizes',
        promotion: {
            id: 'weekly-prizes',
            title: Verbiage.rocket_weekly_prizes_title,
            description: Verbiage.rocket_weekly_prizes_description,
            buttonText: Verbiage.join_now,
            url: '/promotion-page/weekly-prizes/',
            startDate: new Date('2026-03-04T18:01:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_daily_rewards
        },
        order: { promotions: 5 }
    },
    {
        id: 'rewards-program',
        promotion: {
            id: 'rewards-program',
            title: Verbiage.rewards_program,
            description: Verbiage.rewards_program_description,
            buttonText: Verbiage.more_info,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            customTitleWidth: '70%',
            banner: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_vip_galaxy
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            badgeText: Verbiage.exclusive
        },
        order: { promotions: 6, topSection: 4 }
    },
    {
        id: 'inner-circle-telegram',
        promotion: {
            id: 'inner-circle-telegram',
            title: Verbiage.rocket_inner_circle_telegram_title,
            description: Verbiage.rocket_inner_circle_telegram_description,
            buttonText: Verbiage.join,
            url: 'https://t.me/+Zr6A6OTvsvJjYmJi',
            startDate: new Date('2026-06-25T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_mobile.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_desktop.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_exclusive_bonuses
        },
        topSection: {
            title: Verbiage.rocket_inner_circle_telegram_title,
            description: Verbiage.rocket_inner_circle_telegram_description,
            backgroundImage: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_mobile.png'),
            badgeText: Verbiage.exclusive,
            buttonText: Verbiage.join,
            link: 'https://t.me/+Zr6A6OTvsvJjYmJi',
            startDate: new Date('2026-06-25T00:00:00Z')
        },
        order: { promotions: 7, topSection: 5 }
    },
    {
        id: 'rakeboost-promo',
        promotion: {
            id: 'rakeboost-promo',
            title: Verbiage.rocket_rakeboost_promo_title,
            description: Verbiage.rocket_rakeboost_promo_description,
            buttonText: Verbiage.rocket_boost_up,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            banner: cfgToThemeCdnPath('/promotions/rakeboost_promo/rakeboost_promo.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_boost_your_rewards
        },
        order: { promotions: 8 }
    }
];
